import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ListItem } from "../menu/ListItem";
import { BiDownArrow, BiUpArrow } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { UiConstants } from "../../data/UiConstants";
import { executableUndoableMapEditorSetTileInteractionTriggerStatus } from "../../stores/undo/operation/MapEditorSetTileInteractionTriggerData";
import { observer } from "mobx-react-lite";
import { conflictResolutionOriginStep, tileMaxOffsetXY, tileOffsetAndSizeStep } from "../../../shared/data/mapElementSorting";
import { FloatInputField } from "../shared/FloatInputField";
import { undoableMapEditorResetTileConflictResolutionOriginOverride, undoableMapEditorResetTileOffsetOverride, undoableMapEditorSetAdditionalTileOffsetX, undoableMapEditorSetAdditionalTileOffsetY, undoableMapEditorSetAdditionalTileOffsetZ, undoableMapEditorSetTileConflictResolutionFlatZIndex, undoableMapEditorSetTileConflictResolutionOriginOverride } from "../../stores/undo/operation/MapEditorSetTileConflictResolutionValue";
import { clamp } from "curve-interpolator";
import { IntInputField } from "../shared/IntInputField";
import { GrClear } from "react-icons/gr";
import { getTileLayerType } from "../../../shared/data/layerConstants";
import { TileLayerType } from "../../../shared/resources/TileLayerType";
import { MathE } from "../../../shared/helper/MathExtension";
import { sharedStore } from "../../stores/SharedStore";
const LayerContainer = styled(ListItem).withConfig({
  displayName: "EditorTileInspectorLayer__LayerContainer",
  componentId: "sc-1ua6mu-0"
})(["cursor:default;"]);
const Line = styled.div.withConfig({
  displayName: "EditorTileInspectorLayer__Line",
  componentId: "sc-1ua6mu-1"
})(["display:flex;"]);
const LayerTypeInfo = styled.span.withConfig({
  displayName: "EditorTileInspectorLayer__LayerTypeInfo",
  componentId: "sc-1ua6mu-2"
})(["margin-right:6px;"]);
const ChangeDetails = styled.div.withConfig({
  displayName: "EditorTileInspectorLayer__ChangeDetails",
  componentId: "sc-1ua6mu-3"
})(["margin-left:20px;"]);
const ButtonContainer = styled.span.withConfig({
  displayName: "EditorTileInspectorLayer__ButtonContainer",
  componentId: "sc-1ua6mu-4"
})(["margin-left:auto;"]);
const TileAssetId = styled.span.withConfig({
  displayName: "EditorTileInspectorLayer__TileAssetId",
  componentId: "sc-1ua6mu-5"
})(["max-width:170px;display:inline-block;overflow-x:clip;text-overflow:ellipsis;white-space:nowrap;"]);
const BackgroundIndicator = styled.div.withConfig({
  displayName: "EditorTileInspectorLayer__BackgroundIndicator",
  componentId: "sc-1ua6mu-6"
})(["display:flex;width:14px;background:", ";height:14px;border:1px;border-color:black;border-style:solid;align-items:center;justify-content:center;margin-top:1px;"], props => props.isSet ? '#7e7e7e' : 'unset');
const ForegroundIndicator = styled.div.withConfig({
  displayName: "EditorTileInspectorLayer__ForegroundIndicator",
  componentId: "sc-1ua6mu-7"
})(["width:65%;background:", ";height:65%;border:1px;border-color:black;border-style:solid;"], props => props.isSet ? '#0e0d0d' : 'white');
export const LayerEditButton = styled.button.withConfig({
  displayName: "EditorTileInspectorLayer__LayerEditButton",
  componentId: "sc-1ua6mu-8"
})(["border:none;cursor:pointer;background:none;width:20px;&:hover{color:", ";}&:active{color:", ";}"], () => UiConstants.COLOR_DARK_BUTTON_HOVER, () => UiConstants.COLOR_SELECTION_HIGHLIGHT);
const SwapDownButton = styled(LayerEditButton).withConfig({
  displayName: "EditorTileInspectorLayer__SwapDownButton",
  componentId: "sc-1ua6mu-9"
})(["margin-right:20px;"]);
const ClearButton = styled(LayerEditButton).withConfig({
  displayName: "EditorTileInspectorLayer__ClearButton",
  componentId: "sc-1ua6mu-10"
})(["vertical-align:text-top;"]);
const InteractionTriggerSection = styled.div.withConfig({
  displayName: "EditorTileInspectorLayer__InteractionTriggerSection",
  componentId: "sc-1ua6mu-11"
})(["margin-top:5px;"]);
export const LayerDeleteButton = styled(LayerEditButton).withConfig({
  displayName: "EditorTileInspectorLayer__LayerDeleteButton",
  componentId: "sc-1ua6mu-12"
})(["color:red;&:hover{color:darkred;}"]);
const overrideStyle = {};
const nonOverrideStyle = {
  color: "#AAA"
};
const offsetPrecision = 100;

const adjustOffsetPrecision = value => MathE.adjustPrecision(value, offsetPrecision);

export const EditorTileInspectorLayer = observer(properties => {
  var _sharedStore$getTileA, _sharedStore$getTileA2;

  const {
    t
  } = useTranslation();
  const {
    tileData,
    mapEditorStore
  } = properties;
  const {
    currentMapStore
  } = mapEditorStore;

  if (!tileData) {
    return /*#__PURE__*/React.createElement(LayerContainer, null, /*#__PURE__*/React.createElement(Line, null, /*#__PURE__*/React.createElement(LayerTypeInfo, null, /*#__PURE__*/React.createElement(BackgroundIndicator, {
      isSet: false
    }, /*#__PURE__*/React.createElement(ForegroundIndicator, {
      isSet: false
    }))), /*#__PURE__*/React.createElement(TileAssetId, null, t("editor.empty"))));
  }

  const {
    layer
  } = tileData.position;
  const {
    hasConflictResolutionOriginOverride
  } = tileData;
  const isDecoration = getTileLayerType(layer) === TileLayerType.Decoration;
  const tileAsset = sharedStore.getTileAsset(tileData.tileAssetId);
  const conflictResolutionOrigin = hasConflictResolutionOriginOverride ? tileData.conflictResolutionOriginOverride : tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.conflictResolutionOrigin;
  return /*#__PURE__*/React.createElement(LayerContainer, null, /*#__PURE__*/React.createElement(Line, null, /*#__PURE__*/React.createElement(LayerTypeInfo, null, /*#__PURE__*/React.createElement(BackgroundIndicator, {
    isSet: ((_sharedStore$getTileA = sharedStore.getTileAsset(tileData.tileAssetId)) === null || _sharedStore$getTileA === void 0 ? void 0 : _sharedStore$getTileA.imageAssets[0]) !== null
  }, /*#__PURE__*/React.createElement(ForegroundIndicator, {
    isSet: ((_sharedStore$getTileA2 = sharedStore.getTileAsset(tileData.tileAssetId)) === null || _sharedStore$getTileA2 === void 0 ? void 0 : _sharedStore$getTileA2.imageAssets[2]) !== null
  }))), /*#__PURE__*/React.createElement(TileAssetId, null, tileData.tileAssetId), /*#__PURE__*/React.createElement(ButtonContainer, null, properties.swapDown && /*#__PURE__*/React.createElement(SwapDownButton, {
    onClick: () => {
      properties.swapDown(tileData);
    }
  }, /*#__PURE__*/React.createElement(BiDownArrow, null)), properties.swapUp && /*#__PURE__*/React.createElement(LayerEditButton, {
    onClick: () => {
      properties.swapUp(tileData);
    }
  }, /*#__PURE__*/React.createElement(BiUpArrow, null)), /*#__PURE__*/React.createElement(LayerDeleteButton, {
    onClick: () => {
      properties.delete(tileData);
    }
  }, /*#__PURE__*/React.createElement(AiFillDelete, null)))), /*#__PURE__*/React.createElement(Line, null, /*#__PURE__*/React.createElement(ChangeDetails, null, properties.showOffsetOverride && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FloatInputField, {
    style: _objectSpread({
      width: "3.5em"
    }, tileData.additionalOffsetX !== 0 ? overrideStyle : nonOverrideStyle),
    value: adjustOffsetPrecision(tileData.additionalOffsetX + (tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.offsetX)),
    onlyPositive: true,
    step: tileOffsetAndSizeStep,
    min: 0,
    max: tileMaxOffsetXY,
    onChange: value => undoableMapEditorSetAdditionalTileOffsetX(currentMapStore, tileData, clamp(adjustOffsetPrecision(value), 0, tileMaxOffsetXY) - (tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.offsetX))
  }), /*#__PURE__*/React.createElement(FloatInputField, {
    style: _objectSpread({
      width: "3.5em"
    }, tileData.additionalOffsetY !== 0 ? overrideStyle : nonOverrideStyle),
    value: adjustOffsetPrecision(tileData.additionalOffsetY + (tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.offsetY)),
    onlyPositive: true,
    step: tileOffsetAndSizeStep,
    min: 0,
    max: tileMaxOffsetXY,
    onChange: value => undoableMapEditorSetAdditionalTileOffsetY(currentMapStore, tileData, clamp(adjustOffsetPrecision(value), 0, tileMaxOffsetXY) - (tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.offsetY))
  }), /*#__PURE__*/React.createElement(FloatInputField, {
    style: _objectSpread({
      width: "3.5em"
    }, tileData.additionalOffsetZ !== 0 ? overrideStyle : nonOverrideStyle),
    value: adjustOffsetPrecision(tileData.additionalOffsetZ + (tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.internalOffsetZ)),
    onlyPositive: true,
    step: tileOffsetAndSizeStep,
    min: 0,
    onChange: value => undoableMapEditorSetAdditionalTileOffsetZ(currentMapStore, tileData, Math.max(adjustOffsetPrecision(value), 0) - (tileAsset === null || tileAsset === void 0 ? void 0 : tileAsset.internalOffsetZ))
  }), /*#__PURE__*/React.createElement(ClearButton, null, /*#__PURE__*/React.createElement(GrClear, {
    onClick: () => undoableMapEditorResetTileOffsetOverride(currentMapStore, tileData)
  }))), properties.showConflictResolutionOriginEditor && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FloatInputField, {
    style: _objectSpread({
      width: "3.5em"
    }, hasConflictResolutionOriginOverride ? overrideStyle : nonOverrideStyle),
    value: conflictResolutionOrigin,
    onlyPositive: true,
    step: conflictResolutionOriginStep,
    onChange: value => undoableMapEditorSetTileConflictResolutionOriginOverride(currentMapStore, tileData, clamp(value, 0, 1)),
    onMouseEnter: () => properties.mapEditorStore.setHoveredConflictResolutionOriginTileData(tileData),
    onMouseLeave: () => properties.mapEditorStore.setHoveredConflictResolutionOriginTileData(null)
  }), /*#__PURE__*/React.createElement(ClearButton, null, /*#__PURE__*/React.createElement(GrClear, {
    onClick: () => undoableMapEditorResetTileConflictResolutionOriginOverride(currentMapStore, tileData)
  }))), properties.showConflictResolutionZIndexEditor && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IntInputField, {
    style: {
      width: "2.95em"
    },
    value: tileData.conflictResolutionFlatZIndex,
    onChange: value => undoableMapEditorSetTileConflictResolutionFlatZIndex(currentMapStore, tileData, value)
  })), isDecoration && /*#__PURE__*/React.createElement(InteractionTriggerSection, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: tileData.isInteractionTrigger,
    onChange: () => executableUndoableMapEditorSetTileInteractionTriggerStatus(currentMapStore, tileData, !tileData.isInteractionTrigger)
  }), "\xA0", t("editor.element_is_interaction_trigger"))))));
});